import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import { DescriptionField, CheckBox } from "components/support";
import { pathOr } from "ramda";
import style from "./style";
import _ from "lodash";

class CompanyAppConfig extends Component {
  render() {
    const { company, className } = this.props;
    const has_email_low_stock =
      _.indexOf(company.features, "email_low_stock") > -1;
    const has_block_sale_when_stock_is_zero =
      _.indexOf(company.features, "block_sale_when_stock_is_zero") > -1;
    const has_show_sellable_list =
      _.indexOf(company.features, "show_sellable_list") > -1;
    const has_print_sale_list =
      _.indexOf(company.features, "print_sale_list") > -1;
    const has_print_detailed_sale =
      _.indexOf(company.features, "print_detailed_sale") > -1;
    const has_show_sellable_image =
      _.indexOf(company.features, "show_sellable_image") > -1;
    const has_scan_barcode_by_camera =
      _.indexOf(company.features, "scan_barcode_by_camera") > -1;
    const has_open_sales = _.indexOf(company.features, "open_sales") > -1;
    const has_customers = _.indexOf(company.features, "customers") > -1;
    const has_use_large_cards =
      _.indexOf(company.features, "use_large_cards") > -1;
    const has_use_medium_cards =
      _.indexOf(company.features, "use_medium_cards") > -1;
    let size_mobile_card = "";

    if (has_use_large_cards) {
      size_mobile_card = "Grande";
    } else if (has_use_medium_cards) {
      size_mobile_card = "Médio";
    } else {
      size_mobile_card = "Normal";
    }
    return (
      <div className={`${className} grid-container`}>
        <Row bottom="xs">
          <Col xs={6}>
            <CheckBox
              checked={has_print_sale_list}
              style={checkBoxStyle}
              label="Imprimir relatório de vendas"
              disabled={true}
            />
          </Col>
          <Col xs={6}>
            <CheckBox
              checked={has_print_detailed_sale}
              style={checkBoxStyle}
              label="Imprimir venda detalhada"
              disabled={true}
            />
          </Col>
        </Row>
        <Row bottom="xs">
          <Col xs={6}>
            <CheckBox
              checked={has_show_sellable_image}
              style={checkBoxStyle}
              label="Mostrar imagens dos produtos"
              disabled={true}
            />
          </Col>
          <Col xs={6}>
            <CheckBox
              checked={has_scan_barcode_by_camera}
              style={checkBoxStyle}
              label="Usar camera como leitor"
              disabled={true}
            />
          </Col>
        </Row>
        <Row bottom="xs">
          <Col xs={6}>
            <CheckBox
              checked={has_open_sales}
              style={checkBoxStyle}
              label="Permitir fazer venda em aberto"
              disabled={true}
            />
          </Col>
          <Col xs={6}>
            <CheckBox
              checked={has_customers}
              style={checkBoxStyle}
              label="Gerenciar clientes"
              disabled={true}
            />
          </Col>
        </Row>
        <Row bottom="xs">
          <Col xs={6}>
            <CheckBox
              checked={has_email_low_stock}
              style={checkBoxStyle}
              label="Ativar notificação de estoque mínimo"
              disabled={true}
            />
          </Col>
          <Col xs={6}>
            <CheckBox
              checked={has_block_sale_when_stock_is_zero}
              style={checkBoxStyle}
              label="Bloquear vendas com estoque negativo"
              disabled={true}
            />
          </Col>
        </Row>
        <Row bottom="xs">
          <Col xs={6}>
            <DescriptionField
              value={size_mobile_card}
              label="Tamanho dos Cards dos Produtos"
            />
          </Col>
          <Col xs={6}>
            <DescriptionField
              value={company.notify_email}
              label="E-mail de aviso de estoque mínimo atingido"
            />
          </Col>
        </Row>
        <Row>
          <Col xs={6}>
            <DescriptionField
              label="Quantidade Máxima de Parcelas"
              value={company.max_installments ? company.max_installments : null}
            />
          </Col>
          <Col xs={12}>
            <DescriptionField
              label="UUID da Empresa"
              value={company.uuid ? company.uuid : null}
            />
          </Col>
        </Row>
        <Row bottom="xs">
          <Col xs={12}>
            <CheckBox
              checked={has_show_sellable_list}
              style={checkBoxStyle}
              label="Exibir atalhos para produtos no Aplicativo"
              disabled={true}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} className="additional-message-template">
            <DescriptionField
              label="Mensagem adicional dos recibos"
              multiLine
              value={pathOr(null, ["receipt_additional_message"])(company)}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} className="email-template">
            <DescriptionField
              label="Template de email"
              multiLine
              value={pathOr(null, ["email_texts", "sale_document"])(company)}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

const checkBoxStyle = {
  paddingLeft: 4
};

export default style(CompanyAppConfig);



// WEBPACK FOOTER //
// ./src/components/app/registration/company/view/config-app/index.jsx